import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import { checkImpersonationActive, logErrorToConsole } from 'src/utils/util';
import {
    ProductGuideListContainer,
    BodyTextContainer1,
    Sales1,
    Sales2,
    Sales3,
    Line,
    Desktop,
    Mobile,
    Container,
    Heading,
    BodyGridContainer,
    NameGrid,
    UserName,
    Sales,
    SapId,
    Role,
    SortIcon,
    Network,
    NetworkGrid,
    RoleGrid,
    SalesGrid,
    ActionGrid,
    EditIconContainer,
    EditContainer,
    ImpersonateIconContainer,
    ImpersonateContainer,
    StyledImage,
    ButtonLabel,
    HeaderTextContainer,
    HeaderGridContainer,
    HeaderTextContainer1,
    SearchBoxContainer,
    MainContainer,
    RadioButtonView,
    DropDownStyle,
    StyledSortIcon,
    PopupContainer,
    SubMainContainer,
    SearchContainer,
    SalesDiv,
    SearchDiv,
    StyledIcon,
    OtherSalesDiv,
    OtherSalesGrid,
} from './index.styled';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import ViewFilters from 'src/pages/admin/filter/filterResult';
import FilterResultsPanel from 'src/common/organisms/filterResultsPanel/FilterResultsPanel';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import ImpersonateProxy from 'src/pages/admin/impersonateProxy';
import UpdateProxy from 'src/pages/admin/nameDetails/editSsa.jsx';
import NameDetails from 'src/pages/admin/nameDetails/index';
import SortGeneral from 'src/assets/images/SortGeneral.svg';
import Edit from 'src/assets/images/Edit.svg';
import Impersonate from 'src/assets/images/Impersonate.svg';
import ImpersonateDisabled from 'src/assets/images/Impersonate_disable.png';
import Lock from 'src/assets/images/Lock.svg';
import Select from 'src/common/refactoredComponents/select/Select';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import SortTableAscending from 'src/assets/images/SortTableAscending.svg';
import SortTableDescending from 'src/assets/images/SortTableDescending.svg';
import SearchBox from 'src/common/refactoredComponents/searchbox/index';
import {
    getAdminAccountDetails,
    getAdminPhysicianList,
    setSearchTypeAction,
    setAdminSearchParams,
    setloggedUserRolechange,
    clearNewAssignment,
    getAdminUserListSearch,
    setPopDone,
    setshowProxy,
    clearErrorMessage,
} from 'src/pages/admin/redux/action/index.js';
import { setAdminSearchOpen } from 'src/pages/admin/redux/action';
import {
    CS_USER_ROLE,
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    SR_USER_ROLE,
} from 'src/constants/appConstants';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import {
    getFilterData,
    setMoreClick,
    getAdminUserList,
    setClearFilter,
    setAdminFilterOpen,
    setSelectedSalesOrg,
    setSelectedViews,
    clearAdminFilters,
} from 'src/pages/admin/redux/action';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useTranslation } from 'react-i18next';

const AdminList = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // const [showPage, setshowPage] = useState(false);
    const [, setClearFilterClicked] = useState(false);
    // const [searchParam, setSearchParam] = useState('');
    const winWidth = window.innerWidth;
    const [impersonateProxyData, setImpersonateProxyData] = useState({});
    const [showImpersonateProxy, setshowImpersonateProxy] = useState(false);
    const [impersonateProxy] = useState(false);

    const [proxyData, setProxyData] = useState({});
    const [showUpdateProxy, setshowUpdateProxy] = useState(false);
    const [updateProxy] = useState(false);

    const [NameDetailsData, setNameDetailsData] = useState({});
    const [showNameDetails, setshowNameDetails] = useState(false);
    const [nameDetails] = useState(false);
    const [searchType, setSearchType] = useState('user');
    const [adminUserInfo, setadminUserInfo] = useState([]);
    const [sortOrderName] = useState('ASC');
    const [selectedOption, setselectedOption] = useState({
        id: '1',
        label: t('admin.adminList.lastName'),
        code: 'name-asc',
    });
    const popDone = useSelector((state) => state.AdminReducer.popDone);
    const salesOrgFilter = useSelector(
        (state) => state.AdminReducer.adminUser?.salesOrgFilter
    );
    const salesOrgAdminReducer  = useSelector(
        (state) => state.AdminReducer.salesOrg
    );

    const popUpDetails = useRef(0);

    const [sortOrderResponse, setSortOrderResponse] = useState('');
    const [sortParamAPI, setSortParamAPI] = useState('');
    const saleOrgView = useSelector(
        (state) => state.AdminReducer.selectedSalesOrgView
    );
    const appliedView = useSelector((state) => state.AdminReducer.appliedView);
    const [showSortParam, setShowSortParam] = useState('name');

    const adminImperonationEndStatus = useSelector(
        (state) => state.AdminProxyReducer.terminationStatusCode
    );
    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );
    useEffectWithErrorLogging(() => {
        if (
            sessionStorage.getItem('adminImpersonation') &&
            !checkImpersonationActive()
        ) {
            if (!popDone) {
                setshowNameDetails(true);
                dispatch(setPopDone(true));
                popUpDetails.current = popUpDetails.current + 1;
            }

            setNameDetailsData(
                JSON.parse(sessionStorage.getItem('SelectedUserData'))
            );
            dispatch(
                getAdminAccountDetails({
                    principalUser: JSON.parse(
                        sessionStorage.getItem('SelectedUserData')
                    ).networkIdName,
                })
            );
            dispatch(
                setloggedUserRolechange(
                    JSON.parse(sessionStorage.getItem('SelectedUserData'))
                        .userRoles?.[0]
                )
            );
            dispatch(
                getAdminPhysicianList({
                    principalUser: JSON.parse(
                        sessionStorage.getItem('SelectedUserData')
                    ).networkIdName,
                })
            );
        }
    }, [adminImperonationEndStatus]);
    const adminUserList = useSelector(
        (state) => state.AdminReducer.adminUserList
    );

    useEffectWithErrorLogging(() => {
        if (props.fromSearch) {
            setadminUserInfo(props.searchResults);
        } else if (adminUserList && adminUserList.length > 0) {
            setadminUserInfo(adminUserList);
        } else if (adminUserList.length === 0) {
            setadminUserInfo([]);
        }
    }, [adminUserList, props.searchResults]);

    const sortOrderResponseValue = useSelector(
        (state) => state.AdminReducer.sortOrder
    );
    const sortParamAPIValue = useSelector(
        (state) => state.AdminReducer.sortParam
    );
    const loading = useSelector((state) => state.AdminReducer.loading);
    useEffectWithErrorLogging(() => {
        // if (selectedOption) {
        const sortVar = selectedOption.code.split('-');
        setSortOrderResponse(sortVar[1].toUpperCase());
        setSortParamAPI(sortVar[0]);
        setShowSortParam(sortVar[0]);

        // }
        // else {
        // setSortOrderResponse(sortOrderResponseValue);
        // setSortParamAPI(sortParamAPIValue);
        // // }
    }, [sortOrderResponseValue, sortParamAPIValue, selectedOption]);
    useEffectWithErrorLogging(() => {
        if (
            (sortOrderResponseValue === 'ASC' ||
                sortOrderResponseValue === 'ASC') &&
            (sortParamAPIValue === 'name' || sortParamAPIValue === 'Name')
        ) {
            setselectedOption({
                id: '1',
                label: t('admin.adminList.lastName'),
                code: 'name-asc',
                className: 'customDropDown',
            });
        }
        if (
            (sortOrderResponseValue === 'DESC' ||
                sortOrderResponseValue === 'desc') &&
            (sortParamAPIValue === 'name' || sortParamAPIValue === 'Name')
        ) {
            setselectedOption({
                id: '2',
                label: t('admin.adminList.lastNameDesc'),
                code: 'name-desc',
                className: 'customDropDown',
            });
        }
        if (
            (sortOrderResponseValue === 'ASC' ||
                sortOrderResponseValue === 'asc') &&
            sortParamAPIValue === 'networkIdName'
        ) {
            setselectedOption({
                id: '3',
                label: t('admin.adminList.networkAsc'),
                code: 'networkIdName-asc',
                className: 'customDropDown',
            });
        }
        if (
            (sortOrderResponseValue === 'DESC' ||
                sortOrderResponseValue === 'desc') &&
            sortParamAPIValue === 'networkIdName'
        ) {
            setselectedOption({
                id: '4',
                label: t('admin.adminList.networkDesc'),
                code: 'networkIdName-desc',
                className: 'customDropDown',
            });
        }
        if (
            (sortOrderResponseValue === 'ASC' ||
                sortOrderResponseValue === 'asc') &&
            sortParamAPIValue === 'userRole'
        ) {
            setselectedOption({
                id: '3',
                label: t('admin.adminList.roleAsc'),
                code: 'userRole-asc',
                className: 'customDropDown',
            });
        }
        if (
            (sortOrderResponseValue === 'DESC' ||
                sortOrderResponseValue === 'desc') &&
            sortParamAPIValue === 'userRole'
        ) {
            setselectedOption({
                id: '4',
                label: t('admin.adminList.roleDesc'),
                code: 'userRole-desc',
                className: 'customDropDown',
            });
        }
    }, [sortOrderResponseValue, sortParamAPIValue]); 
    const onSortButtonClick = (sortParamValue) => {
        let sortValue = '';
        if (sortParamValue === 'name') {
            sortValue = 'name';
        } else if (sortParamValue === 'networkIdName') {
            sortValue = 'networkIdName';
        } else {
            sortValue = 'userRole';
        }
        const sortParams = {
            sortParam: sortValue,
            sortOrder: sortOrderResponse === 'ASC' ? 'DESC' : 'ASC',
        };

        props.handleSort(sortParams);
    };

    const openNameDetails = (listData) => {
        dispatch(clearErrorMessage(''));
        dispatch(
            getAdminAccountDetails({
                principalUser: listData.networkIdName,
            })
        );
        dispatch(setloggedUserRolechange(listData.userRoles?.[0]));
        dispatch(
            getAdminPhysicianList({ principalUser: listData.networkIdName })
        );
        setNameDetailsData(listData);
        let listDataStrify = JSON.stringify(listData);

        sessionStorage.setItem('SelectedUserData', listDataStrify);
        dispatch(setshowProxy(false));

        setshowNameDetails(true);
    };

    const closeNameDetails = () => {
        dispatch(clearNewAssignment());
        setNameDetailsData({});
        sessionStorage.removeItem('adminImpersonation');
        sessionStorage.removeItem('SelectedUserData');
        setshowNameDetails(false);
    };

    const openImpersonateProxy = (listData) => {
        if (
            !checkImpersonationActive() &&
            !checkUserRestriction(listData.userRoles?.[0])
        ) {
            setImpersonateProxyData(listData);
            setshowImpersonateProxy(true);
        }
    };

    const closeImpersonateProxy = () => {
        setImpersonateProxyData({});

        setshowImpersonateProxy(false);
    };

    const impersonationKey = useSelector(
        (state) => state.AdminProxyReducer.impersonationKey
    );

    useEffectWithErrorLogging(() => {
        if (impersonationKey) {
            setshowImpersonateProxy(false);
        }
    }, [impersonationKey]);

    // const openUpdateProxy = (listData) => {
    //     setProxyData(listData);
    //     setshowUpdateProxy(true);
    // };

    const closeUpdateProxy = () => {
        setProxyData({});

        setshowUpdateProxy(false);
    };

    // const statusCode = useSelector(
    //     (state) => state.searchProductsReducer.statusCode
    // );

    const updateSearch = (val) => {
        props.setSearchValue(val);
    };
    const { adminSearchOpen } = useSelector((state) => ({
        adminSearchOpen: state.AdminReducer.adminSearchOpen,
    }));
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const initiateProxyStatus = useSelector(
        (state) => state.AdminProxyReducer.initiateProxyStatus
    );
    useEffectWithErrorLogging(() => {
        if (initiateProxyStatus === '200') {
            if (!props.fromSearch) {
                props.setSearchValue('');
            }
        }
    }, [initiateProxyStatus]);

    // useEffectWithErrorLogging(() => {
    //     if (statusCode && statusCode === '10001') {
    //         setshowPage(true);
    //     }
    // }, [statusCode, searchParam]);
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // dispatch(searchProducts({ searchTerm: event.target.value }));

            sessionStorage.setItem('adminSearch', true);
            event.target.blur();
            let salesOrgsData = [];
            salesOrgAdminReducer &&
                salesOrgAdminReducer.map((item) => {
                    if (
                        item.isChecked ||
                        (!Object.prototype.hasOwnProperty.call(
                            item,
                            'isChecked'
                        ) &&
                            item.isDefault)
                    ) {
                        salesOrgsData.push(item.value);
                    }
                });
            let Param = {
                networkIdName: props.searchValue.trim(),
                filteredDistrict: appliedView && appliedView.appliedDistrict.id,
                filteredTerritory:
                    appliedView && appliedView.appliedTerritory.id,
                filteredRole: appliedView && appliedView.appliedRole.id,
                salesOrgs: salesOrgsData && salesOrgsData.join(','),
            };
            dispatch(getAdminUserListSearch(Param));
            dispatch(setAdminSearchOpen(true));
            dispatch(setSearchTypeAction('Users'));
            dispatch(setAdminSearchParams(props.searchValue.trim()));
        }
    };

    const handleKeyPressAccount = (event) => {
        // setSearchParam(event.target.value);
        if (event.key === 'Enter') {
            // dispatch(searchProducts({ searchTerm: event.target.value }));
            sessionStorage.setItem('adminSearch', true);
            event.target.blur();
            let salesOrgsData = [];
            salesOrgFilter &&
                salesOrgFilter.map((item) => {
                    if (
                        item.isChecked ||
                        (!Object.prototype.hasOwnProperty.call(
                            item,
                            'isChecked'
                        ) &&
                            item.isDefault)
                    ) {
                        salesOrgsData.push(item.value);
                    }
                });
            let Param = {
                accountNameId: props.searchValue.trim(),
                filteredDistrict: appliedView.appliedDistrict.id,
                filteredTerritory: appliedView.appliedTerritory.id,
                filteredRole: appliedView.appliedRole.id,
                salesOrgs: salesOrgsData.join(','),
            };
            dispatch(getAdminUserListSearch(Param));
            dispatch(setAdminSearchOpen(true));
            dispatch(setSearchTypeAction('Accounts'));
            dispatch(setAdminSearchParams(props.searchValue.trim()));
        }
    };
    const handleClearSearch = () => {
        props.setSearchValue('');
        // setshowPage(false);
        // dispatch(
        //     getDetailedProductTemplateList({
        //         templateSubCategoryCode: categoryName,
        //         ...detailedProducts.pagination,
        //         ...filterApplied,
        //     })
        // );
    };
    const changeSearchType = (type) => {
        props.setSearchValue('');
        setSearchType(type);
    };
    const userRoleCheck = [
        'MDT Spine CSR',
        'MDT Spine CC',
        'MDT Spine FIM',
        'MDT Spine ITA',
        'MDT Spine SP',
    ];
    const DropdownOption = {
        template: [
            {
                id: '1',
                label: t('admin.adminList.lastName'),
                code: 'name-asc',
                className: 'customDropDown',
            },
            {
                id: '2',
                label: t('admin.adminList.lastNameDesc'),
                code: 'name-desc',
                className: 'customDropDown',
            },
            {
                id: '3',
                label: t('admin.adminList.roleAsc'),
                code: 'userRole-asc',
                className: 'customDropDown',
            },
            {
                id: '4',
                label: t('admin.adminList.roleDesc'),
                code: 'userRole-desc',
                className: 'customDropDown',
            },
            {
                id: '3',
                label: t('admin.adminList.networkAsc'),
                code: 'networkIdName-asc',
                className: 'customDropDown',
            },
            {
                id: '4',
                label: t('admin.adminList.networkDesc'),
                code: 'networkIdName-desc',
                className: 'customDropDown',
            },
        ],
    };
    const onDropdownChange = (selectedOption) => {
        const sortVar = selectedOption.code.split('-');

        setselectedOption(selectedOption);
        const sortParams = {
            sortParam: sortVar[0],
            sortOrder: sortVar[1],
        };

        props.handleSort(sortParams);
        // dispatch(setUserRolechange(selectedOption));
    };
    const checkUserRestriction = (role) => {
        return (
            getUser() == FIM_USER_ROLE &&
            ![SR_USER_ROLE, CS_USER_ROLE, FIA_USER_ROLE].includes(role)
        );
    };

       const handleClearClick = () => {
            props.setIsFilterUpdated(!props.isFilterUpdated);
            sessionStorage.removeItem('items');
            sessionStorage.removeItem('SalesOrgView');
            if (!isImpersonationActive) {
                sessionStorage.removeItem('selectedViews');
                sessionStorage.removeItem('param');
                sessionStorage.removeItem('appliedData');
            }
            setClearFilterClicked(true);
            dispatch(setClearFilter(true));
            dispatch(getFilterData(false));
    
            // dispatch(getAdminUserList());
            props.resetHandler();
            let salesOrgData = saleOrgView &&
                saleOrgView.length > 0 && [...saleOrgView];
            salesOrgData &&
                salesOrgData.length > 0 &&
                salesOrgData.map((item) => {
                    if (item.isDefault) {
                        item.isChecked = true;
                    } else {
                        item.isChecked = false;
                    }
                });
            dispatch(
                setSelectedViews({
                    salesOrgView: salesOrgData,
                    districtView: { id: 'All District', name: 'All' },
                    territoryView: { id: 'All Territory', name: 'All' },
                    roleView: { id: 'All', name: 'All' },
                })
            );
            dispatch(setSelectedSalesOrg(salesOrgData));
    
            dispatch(clearAdminFilters(true));
        };
    return (
        <>
            <MainContainer>
                {props.fromSearch ? null : (
                    <>
                        <BodyTextContainer1
                            item
                            xs={12}
                            sm={1}
                            md={12}
                            lg={12}
                            xl={12}
                            mobile={12}
                            className="title-search"
                        >
                            {t('admin.adminList.search')}
                        </BodyTextContainer1>
                        <SubMainContainer>
                            <SearchContainer>
                                <div style={{ display: 'flex' }}>
                                    {/* <SearchDiv>
                                        {t('admin.adminList.search')}
                                    </SearchDiv> */}
                                    <RadioButtonView>
                                        <Grid lg={12} sm={12} xs={12}>
                                            <RadioButton
                                                id={'admin-search-user'}
                                                label={t('admin.adminList.users')}
                                                fontFamilyStyle="AvenirNextWorld Regular"
                                                value={searchType}
                                                isChecked={
                                                    searchType == 'user'
                                                        ? true
                                                        : false
                                                }
                                                handleChange={() => {
                                                    try {
                                                        changeSearchType('user');
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </RadioButtonView>
                                    {/* <BodyTextContainer1
                                        style={{
                                            fontSize: '16px',
                                            fontFamily:
                                                'AvenirNextWorld Regular',
                                            paddingLeft: '10px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            setSearchType('user');
                                        }}
                                    >
                                        {t('admin.adminList.users')}
                                    </BodyTextContainer1> */}
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <RadioButtonView>
                                        <Grid lg={12} sm={12} xs={12}>
                                            <RadioButton
                                                id={'admin-search-account'}
                                                label={t('admin.adminList.accounts')}
                                                fontFamilyStyle="AvenirNextWorld Regular"
                                                value={searchType}
                                                isChecked={
                                                    searchType == 'account'
                                                        ? true
                                                        : false
                                                }
                                                handleChange={() => {
                                                    try {
                                                        changeSearchType('account');
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </RadioButtonView>
                                    {/* <BodyTextContainer1
                                        style={{
                                            fontSize: '16px',
                                            fontFamily:
                                                'AvenirNextWorld Regular',
                                            paddingLeft: '2px',
                                            cursor: 'pointer',
                                            // marginRight: '24px',
                                        }}
                                        onClick={() => {
                                            setSearchType('account');
                                        }}
                                    >
                                        {t('admin.adminList.accounts')}
                                    </BodyTextContainer1> */}
                                </div>
                            </SearchContainer>
                            {searchType === 'user' ? (
                                <SearchBoxContainer
                                    item
                                    sm={6}
                                    right={'6%'}
                                    autoComplete="off"
                                >
                                    <SearchBox
                                        id="admin-adminList-user-searchbox"
                                        margin={'auto 0px auto 0px'}
                                        updateSearch={updateSearch}
                                        searchProduct={props.searchValue}
                                        placeholder={t(
                                            'admin.adminList.enterUnameOrNid'
                                        )}
                                        width={
                                            winWidth <= sizes.mobileDevice
                                                ? '100%'
                                                : winWidth <= sizes.mediumDevice || countryISOCode === COUNTRY_CODE_JAPN
                                                ? '350px'
                                                : '310px'
                                        }
                                        // margin={isMobileDevice() ? '0' : ''}
                                        marginDesktop={'8px 8px'}
                                        containerMobileWidth={'100%'}
                                        height={'40px'}
                                        borderRadius={'20px'}
                                        paddingLeft={'2.2rem'}
                                        isSearchIcon={true}
                                        searchIconWidth={'min-content'}
                                        fontSize={'14px'}
                                        handleKeyPress={handleKeyPress}
                                        clearSearch={handleClearSearch}
                                        background={'none'}
                                        enterkeyhint={'go'}
                                        borderLeft={'none'}
                                        labelColor="#040404"
                                        fontWeight="400"
                                        fontFamily="AvenirNextWorld, Regular"
                                        padding={'0.5rem 2.2rem 0.6rem'}
                                        autoComplete="off"
                                    />
                                </SearchBoxContainer>
                            ) : (
                                <SearchBoxContainer
                                    item
                                    sm={6}
                                    right={'6%'}
                                    //style={{ marginLeft: '-15px' }}
                                >
                                    <SearchBox
                                        id="admin-adminList-account-searchbox"
                                        margin={'auto 0px auto 0px'}
                                        updateSearch={updateSearch}
                                        searchProduct={props.searchValue}
                                        placeholder={t(
                                            'admin.adminList.enterANumber'
                                        )}
                                        width={
                                            winWidth <= sizes.mobileDevice
                                                ? '100%'
                                                : winWidth <= sizes.mediumDevice || countryISOCode === COUNTRY_CODE_JAPN
                                                ? '350px'
                                                : '310px'
                                        }
                                        marginDesktop={'8px 8px'}
                                        containerMobileWidth={'100%'}
                                        height={'40px'}
                                        borderRadius={'20px'}
                                        paddingLeft={'2.2rem'}
                                        isSearchIcon={true}
                                        searchIconWidth={'min-content'}
                                        fontSize={'14px'}
                                        handleKeyPress={handleKeyPressAccount}
                                        clearSearch={handleClearSearch}
                                        background={'none'}
                                        enterkeyhint={'go'}
                                        borderLeft={'none'}
                                        labelColor="#040404"
                                        fontWeight="400"
                                        fontFamily="AvenirNextWorld, Regular"
                                        padding={'0.5rem 2.2rem 0.6rem'}
                                        autoComplete="off"
                                    />
                                </SearchBoxContainer>
                            )}
                        </SubMainContainer>
                    </>
                )}
                {props.viewFilter ? (
                    <FilterResultsPanel
                        appliedFilters={props.filterValuesArray}
                        resetHandler={props.resetHandler}
                        filterContainerMobilePadding={'0px 0px 0px'}
                        filtersList={saleOrgView}
                        setClearFilterClicked={setClearFilterClicked}
                        marginLeftTemplate = {'0px'}
                        marginTop = {'0px'}
                        clearFilterHandler={handleClearClick}
                    />
                ) : null}
                <DropDownStyle adminSearchOpen={adminSearchOpen}>
                    <StyledSortIcon>
                        <img src={SortGeneral} />
                    </StyledSortIcon>
                    <Select
                        id="admin-index-adminList-lastName"
                        //value={dropdownCode}
                        options={DropdownOption.template}
                        onChange={onDropdownChange}
                        value={selectedOption}
                        placeholder={t('admin.adminList.lastName')}
                        // optionValue="code"
                        // optionLabel="label"
                        width="100%"
                        labelColor="#202124"
                        marginTop="13px"
                        selectedLabelFontSize="14px"
                        fontFamily="AvenirNextWorld, Regular"
                        height={'40px'}
                    />
                </DropDownStyle>
            </MainContainer>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderTextContainer
                    id="admin-index-adminList-sortByName"
                    style={{ display: 'flex' }}
                    item
                    xs={2}
                    sm={2}
                    md={2}
                    lg={2}
                    xl={2}
                    onClick={() => {
                        try {
                            setShowSortParam('name');
                            setSortOrderResponse('ASC');
                            onSortButtonClick('name');
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                    {t('admin.adminList.name')}
                    {/* <SortIcon>
                        <img
                            src={SortTableAscending}
                            alt="SortTableAscending"
                            // value={sortOrderName}
                            width="auto"
                            height="auto"
                            onClick={() => {
                                onSortButtonClick('name');
                            }}
                        ></img>
                    </SortIcon> */}
                    {showSortParam === 'name' && (
                        <SortIcon marginLeft={'49px'}>
                            {sortOrderResponse === 'DESC' &&
                            sortParamAPI === 'name' ? (
                                <img
                                    id="admin-index-adminList-sortByName-asc"
                                    src={SortTableDescending}
                                    alt="SortTableAscending"
                                    value={sortOrderName}
                                    width="auto"
                                    height="auto"
                                    onClick={() => {
                                        try {
                                            onSortButtonClick('name');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            ) : (
                                <img
                                    id="admin-index-adminList-sortByName-asc"
                                    src={SortTableAscending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={sortOrderName}
                                    onClick={() => {
                                        try {
                                            onSortButtonClick('name');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            )}
                        </SortIcon>
                    )}
                </HeaderTextContainer>
                <HeaderTextContainer
                    id="admin-index-adminList-sortByNetworkId"
                    item
                    xs={2}
                    sm={2}
                    md={2}
                    lg={2}
                    xl={2}
                    onClick={() => {
                        try {
                            setShowSortParam('networkIdName');
                            setSortOrderResponse('ASC');
                            onSortButtonClick('networkIdName');
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                    {t('admin.adminList.networkId')}
                    {showSortParam === 'networkIdName' && (
                        <SortIcon marginLeft={'20px'}>
                            {sortParamAPI === 'networkIdName' &&
                            sortOrderResponse === 'DESC' ? (
                                <img
                                    id="admin-index-adminList-sortByNetworkId-desc"
                                    src={SortTableDescending}
                                    alt="SortTableAscending"
                                    // value={sortOrder}
                                    width="auto"
                                    height="auto"
                                    onClick={() => {
                                        try {
                                            onSortButtonClick('networkIdName');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            ) : (
                                <img
                                    id="admin-index-adminList-sortByNetworkId-asc"
                                    src={SortTableAscending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    // value={sortOrder}
                                    onClick={() => {
                                        try {
                                            onSortButtonClick('networkIdName');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            )}
                        </SortIcon>
                    )}
                </HeaderTextContainer>
                <HeaderTextContainer
                    id="admin-index-adminList-sortByRole"
                    item
                    xs={2}
                    sm={2}
                    md={2}
                    lg={2}
                    xl={2}
                    onClick={() => {
                        try {
                            setShowSortParam('userRole');
                            setSortOrderResponse('ASC');
                            onSortButtonClick('userRole');
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                    {t('admin.adminList.role')}
                    {showSortParam === 'userRole' && (
                        <SortIcon marginLeft={'25px'}>
                            {sortParamAPI === 'userRole' &&
                            sortOrderResponse === 'DESC' ? (
                                <img
                                    id="admin-index-adminList-sortByRole-desc"
                                    src={SortTableDescending}
                                    alt="SortTableAscending"
                                    // value={sortOrder}
                                    width="auto"
                                    height="auto"
                                    onClick={() => {
                                        try {
                                            onSortButtonClick('userRole');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            ) : (
                                <img
                                    id="admin-index-adminList-sortByRole-asc"
                                    src={SortTableAscending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    // value={sortOrder}
                                    onClick={() => {
                                        try {
                                            onSortButtonClick('userRole');
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            )}
                        </SortIcon>
                    )}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={3}
                    sm={4}
                    md={3}
                    lg={4}
                    xl={4}
                    style={{ paddingLeft: '0px' }}
                >
                    {t('admin.adminList.salesStructureAsignment')}
                </HeaderTextContainer>
                <HeaderTextContainer1 item xs={3} sm={2} md={3} lg={2} xl={2}>
                    {t('admin.adminList.action')}
                </HeaderTextContainer1>
            </HeaderGridContainer>
            {loading === true ? null : (
                <ProductGuideListContainer
                    isImpersonationActive={checkImpersonationActive()}
                >
                    {adminUserInfo &&
                        adminUserInfo
                            // .filter((e) => e.firstName && e)

                            .map((listData, index) => {
                                return (
                                    <BodyGridContainer
                                        id={`admin-index-adminList-row-${index}`}
                                        container
                                        direction="row"
                                        key={index}
                                        onClick={() => {
                                            try {
                                                openNameDetails(listData);
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                    >
                                        <NameGrid
                                            item
                                            xs={12}
                                            sm={3}
                                            md={2}
                                            lg={2}
                                            xl={2}
                                            mobile={12}
                                        >
                                            {/* <a
                                            onClick={() =>
                                                openNameDetails(listData)
                                            }
                                        > */}{' '}
                                            <UserName className="admin-person-name-dt-mask">
                                                {listData.firstName
                                                    ? listData.firstName + ' '
                                                    : ''}
                                                {listData.lastName
                                                    ? listData.lastName
                                                    : ''}
                                            </UserName>
                                            {/* </a> */}
                                        </NameGrid>

                                        <NetworkGrid
                                            item
                                            xs={12}
                                            sm={3}
                                            md={2}
                                            lg={2}
                                            xl={2}
                                            mobile={12}
                                        >
                                            <Container
                                                style={{ alignItems: 'center' }}
                                            >
                                                <Network>
                                                    {listData.networkIdName}
                                                </Network>
                                                {listData.sapId && (
                                                    <>
                                                        <Line>|</Line>
                                                        <SapId
                                                            style={{
                                                                fontSize:
                                                                    '14px',
                                                                fontFamily:
                                                                    'AvenirNextWorld Regular',
                                                                color: '#202124',
                                                            }}
                                                        >
                                                            {t(
                                                                'admin.adminList.sapId'
                                                            )}{' '}
                                                            <span className="admin-account-address-dt-mask">{accountNumberZeroTrimmer(
                                                                listData.sapId
                                                            )}</span>
                                                        </SapId>
                                                    </>
                                                )}
                                            </Container>
                                        </NetworkGrid>

                                        <RoleGrid
                                            item
                                            xs={12}
                                            sm={3}
                                            md={2}
                                            lg={2}
                                            xl={2}
                                            mobile={12}
                                        >
                                            <Role>{listData.userRoles?.[0]}</Role>
                                        </RoleGrid>

                                        <Mobile
                                            style={{
                                                paddingTop: '10px',
                                                width: '100%',
                                            }}
                                        >
                                            <EditIconContainer>
                                                <EditContainer>
                                                    <a
                                                        id={`admin-index-adminList-editButton-${index}`}
                                                        style={{
                                                            display: 'flex',
                                                        }}
                                                        // onClick={() =>
                                                        //     openUpdateProxy(
                                                        //         listData
                                                        //     )
                                                        // }
                                                        onClick={() => {
                                                            try {
                                                                openNameDetails(
                                                                    listData
                                                                );
                                                            } catch (error) {
                                                                logErrorToConsole(error);
                                                            }
                                                        }}
                                                    >
                                                        <StyledImage
                                                            src={Edit}
                                                            width="auto"
                                                            height="auto"
                                                        />
                                                        <ButtonLabel>
                                                            {t(
                                                                'admin.adminList.edit'
                                                            )}
                                                        </ButtonLabel>
                                                    </a>
                                                </EditContainer>
                                            </EditIconContainer>

                                            {listData.userRoles?.[0] !==
                                            'Un-assigned' ? (
                                                <ImpersonateIconContainer
                                                    // backColor={
                                                    //     checkImpersonationActive()
                                                    //         ? '#9f9f9f'
                                                    //         : '#ffffff'
                                                    // }
                                                    boxShadow={
                                                        checkImpersonationActive() ||
                                                        checkUserRestriction(
                                                            listData
                                                                .userRoles?.[0]
                                                        )
                                                            ? '0px 0px 2px #9f9f9f'
                                                            : '0px 0px 2px #00000029'
                                                    }
                                                    border={
                                                        checkImpersonationActive() ||
                                                        checkUserRestriction(
                                                            listData
                                                                .userRoles?.[0]
                                                        )
                                                            ? '1px solid #9f9f9f'
                                                            : '1px solid #1010eb'
                                                    }
                                                >
                                                    <ImpersonateContainer
                                                        labelColor={
                                                            checkImpersonationActive() ||
                                                            checkUserRestriction(
                                                                listData
                                                                    .userRoles?.[0]
                                                            )
                                                                ? '#9f9f9f'
                                                                : '#1010eb'
                                                        }
                                                    >
                                                        <a
                                                            id={`admin-index-adminList-impersonateButton-${index}`}   
                                                            style={{
                                                                display: 'flex',
                                                            }}
                                                            onClick={(e) => {
                                                                try {
                                                                    openImpersonateProxy(
                                                                        listData
                                                                    );
                                                                    e.stopPropagation();
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                        >
                                                            <StyledImage
                                                                src={
                                                                    checkImpersonationActive() ||
                                                                    checkUserRestriction(
                                                                        listData
                                                                            .userRoles?.[0]
                                                                    )
                                                                        ? ImpersonateDisabled
                                                                        : Impersonate
                                                                }
                                                                width="auto"
                                                                height="auto"
                                                            />
                                                            <ButtonLabel
                                                                labelColor={
                                                                    checkImpersonationActive() ||
                                                                    checkUserRestriction(
                                                                        listData
                                                                            .userRoles?.[0]
                                                                    )
                                                                        ? '#9f9f9f'
                                                                        : '#1010eb'
                                                                }
                                                            >
                                                                {checkUserRestriction(
                                                                    listData
                                                                        .userRoles?.[0]
                                                                )}
                                                                {t(
                                                                    'admin.adminList.impersonate'
                                                                )}
                                                            </ButtonLabel>
                                                        </a>
                                                    </ImpersonateContainer>
                                                </ImpersonateIconContainer>
                                            ) : null}
                                        </Mobile>

                                        <SalesGrid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={4}
                                            xl={4}
                                            mobile={12}
                                            gridOrder={
                                                !userRoleCheck.includes(
                                                    listData.userRoles?.[0]
                                                )
                                                    ? '5'
                                                    : '4'
                                            }
                                        >
                                            {!userRoleCheck.includes(
                                                listData.userRoles?.[0]
                                            ) ? (
                                                <>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        md={12}
                                                        lg={11}
                                                        xl={11}
                                                        mobile={12}
                                                    >
                                                        {listData.salesHirerachy &&
                                                            listData.salesHirerachy
                                                                .filter(
                                                                    (e) =>
                                                                        e.otherSalesAssignment ===
                                                                        false
                                                                )

                                                                .map(
                                                                    (items) => {
                                                                        return (
                                                                            <>
                                                                                <div
                                                                                    className="lock-icon-div"
                                                                                    style={{
                                                                                        display:
                                                                                            'flex',
                                                                                        justifyContent:
                                                                                            'space-between',
                                                                                        alignItems:
                                                                                            'baseline',
                                                                                    }}
                                                                                >
                                                                                    <Sales1 className="before-lock-icon-div">
                                                                                        {(items.jobFunctionCode
                                                                                            ? items.jobFunctionCode
                                                                                            : '') +
                                                                                            (items.jobFunctionCode
                                                                                                ? '-'
                                                                                                : '') +
                                                                                            items.salesOrgName +
                                                                                            '.' +
                                                                                            items.salesForceName +
                                                                                            '.' +
                                                                                            items.structureName}
                                                                                    </Sales1>
                                                                                    <StyledIcon
                                                                                        src={
                                                                                            Lock
                                                                                        }
                                                                                        width="auto"
                                                                                        height="auto"
                                                                                    />
                                                                                </div>
                                                                                <SalesDiv>
                                                                                    <Sales2>
                                                                                        {
                                                                                            items.districtName
                                                                                        }{' '}
                                                                                        {items.territoryName
                                                                                            ? '  •  '
                                                                                            : ''}
                                                                                    </Sales2>
                                                                                    <Sales3>
                                                                                        {' '}
                                                                                        {
                                                                                            items.territoryName
                                                                                        }
                                                                                    </Sales3>
                                                                                </SalesDiv>
                                                                            </>
                                                                        );
                                                                    }
                                                                )}
                                                    </Grid>

                                                    <OtherSalesGrid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        md={12}
                                                        lg={12}
                                                        xl={12}
                                                        mobile={12}
                                                        className="smalDevicePadding"
                                                    >
                                                        {listData.salesHirerachy &&
                                                        listData.salesHirerachy.filter(
                                                            (e) =>
                                                                e.otherSalesAssignment ===
                                                                true
                                                        ).length !== 0 ? (
                                                            <Heading>
                                                                {t(
                                                                    'admin.adminList.otherSalesAssignments'
                                                                )}
                                                            </Heading>
                                                        ) : null}

                                                        {listData.salesHirerachy &&
                                                            listData.salesHirerachy
                                                                .filter(
                                                                    (e) =>
                                                                        e.otherSalesAssignment ===
                                                                        true
                                                                )

                                                                .map(
                                                                    (items) => {
                                                                        return (
                                                                            <>
                                                                                <Sales1
                                                                                    style={{
                                                                                        paddingTop:
                                                                                            '4px',
                                                                                    }}
                                                                                >
                                                                                    {/* SR-S002.US006.000.601.304.000.257 */}
                                                                                    {(items.jobFunctionCode
                                                                                        ? items.jobFunctionCode
                                                                                        : '') +
                                                                                        (items.jobFunctionCode
                                                                                            ? '-'
                                                                                            : '') +
                                                                                        items.salesOrgName +
                                                                                        '.' +
                                                                                        items.salesForceName +
                                                                                        '.' +
                                                                                        items.structureName}
                                                                                </Sales1>
                                                                                <OtherSalesDiv>
                                                                                    <Sales2>
                                                                                        {
                                                                                            items.districtName
                                                                                        }{' '}
                                                                                        {items.territoryName
                                                                                            ? '  •  '
                                                                                            : ''}
                                                                                    </Sales2>
                                                                                    <Sales3>
                                                                                        {' '}
                                                                                        {
                                                                                            items.territoryName
                                                                                        }
                                                                                    </Sales3>
                                                                                </OtherSalesDiv>
                                                                            </>
                                                                        );
                                                                    }
                                                                )}
                                                    </OtherSalesGrid>
                                                </>
                                            ) : (
                                                <Sales>
                                                    {t(
                                                        'admin.adminList.globalUser'
                                                    )}
                                                </Sales>
                                            )}
                                        </SalesGrid>

                                        <ActionGrid
                                            item
                                            xs={12}
                                            sm={3}
                                            md={3}
                                            lg={2}
                                            xl={2}
                                            mobile={6}
                                        >
                                            <Desktop className="impersonate-box">
                                                {listData.userRoles?.[0] !==
                                                'Un-assigned' ? (
                                                    <ImpersonateIconContainer
                                                        // backColor={
                                                        //     checkImpersonationActive()
                                                        //         ? '#9f9f9f'
                                                        //         : '#ffffff'
                                                        // }
                                                        boxShadow={
                                                            checkImpersonationActive() ||
                                                            checkUserRestriction(
                                                                listData
                                                                    .userRoles?.[0]
                                                            )
                                                                ? '0px 0px 2px #9f9f9f'
                                                                : '0px 0px 2px #00000029'
                                                        }
                                                        border={
                                                            checkImpersonationActive() ||
                                                            checkUserRestriction(
                                                                listData
                                                                    .userRoles?.[0]
                                                            )
                                                                ? '1px solid #9f9f9f'
                                                                : '1px solid #1010eb'
                                                        }
                                                    >
                                                        <ImpersonateContainer
                                                            labelColor={
                                                                checkImpersonationActive() ||
                                                                checkUserRestriction(
                                                                    listData
                                                                        .userRoles?.[0]
                                                                )
                                                                    ? '#9f9f9f'
                                                                    : '#1010eb'
                                                            }
                                                        >
                                                            <a
                                                                id={`admin-index-adminList-impersonateButton-${index}`}
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                }}
                                                                onClick={(e) => {
                                                                    try {
                                                                        openImpersonateProxy(
                                                                            listData
                                                                        );
                                                                        e.stopPropagation();
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                            >
                                                                <StyledImage
                                                                    src={
                                                                        checkImpersonationActive() ||
                                                                        checkUserRestriction(
                                                                            listData
                                                                                .userRoles?.[0]
                                                                        )
                                                                            ? ImpersonateDisabled
                                                                            : Impersonate
                                                                    }
                                                                    width="auto"
                                                                    height="auto"
                                                                />
                                                                <ButtonLabel
                                                                    labelColor={
                                                                        checkImpersonationActive() ||
                                                                        checkUserRestriction(
                                                                            listData
                                                                                .userRoles?.[0]
                                                                        )
                                                                            ? '#9f9f9f'
                                                                            : '#1010eb'
                                                                    }
                                                                >
                                                                    {t(
                                                                        'admin.adminList.impersonate1'
                                                                    )}
                                                                </ButtonLabel>
                                                            </a>
                                                        </ImpersonateContainer>
                                                    </ImpersonateIconContainer>
                                                ) : null}

                                                <EditIconContainer>
                                                    <EditContainer>
                                                        <a
                                                            id={`admin-index-adminList-editButton-${index}`}
                                                            style={{
                                                                display: 'flex',
                                                            }}
                                                            // onClick={() =>
                                                            //     openUpdateProxy(
                                                            //         listData
                                                            //     )
                                                            // }
                                                            onClick={() => {
                                                                try {
                                                                    openNameDetails(
                                                                        listData
                                                                    );
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                        >
                                                            <StyledImage
                                                                src={Edit}
                                                                width="20"
                                                                height="24"
                                                            />
                                                            <ButtonLabel>
                                                                {t(
                                                                    'admin.adminList.edit'
                                                                )}
                                                            </ButtonLabel>
                                                        </a>
                                                    </EditContainer>
                                                </EditIconContainer>
                                            </Desktop>
                                        </ActionGrid>
                                    </BodyGridContainer>
                                );
                            })}
                </ProductGuideListContainer>
            )}
            {showImpersonateProxy && (
                <ImpersonateProxy
                    addProxyPopup={impersonateProxy}
                    handleClose={closeImpersonateProxy}
                    isFromAccount={props.isFromAccount}
                    impersonateProxyData={impersonateProxyData}
                    setClearFilterClicked={setClearFilterClicked}
                />
            )}

            {showUpdateProxy && (
                <Popup contentWidth={'50%'} id={'admin-adminList-index-popup'} margin={'15px'}>
                    <PopupContainer>
                        <UpdateProxy
                            addProxyPopup={updateProxy}
                            handleClose={closeUpdateProxy}
                            isFromAccount={props.isFromAccount}
                            proxyData={proxyData}
                        />
                    </PopupContainer>
                </Popup>
            )}

            {showNameDetails && (
                <ModalDialog
                    modalHeight={'calc(100vh - 112px)'}
                    maxWidth={'841px'}
                    marginTop={'32%'}
                    zIndex={'2000'}
                    padding={'0'}
                    top={'8%'}
                    isIPadPotrait={false}
                    handleClose={() => {
                        try {
                            closeNameDetails();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    isAdminPage={true}
                >
                    <PopupContainer>
                        <NameDetails
                            NameDetails={NameDetailsData}
                            addProxyPopup={nameDetails}
                            handleClose={closeNameDetails}
                            isFromAccount={props.isFromAccount}
                            setshowNameDetails={setshowNameDetails}
                            setClearFilterClicked={setClearFilterClicked}
                        />
                    </PopupContainer>
                </ModalDialog>
            )}
        </>
    );
};
export default AdminList;
